import * as React from "react";

interface OwnProps {
    message?: JSX.Element | string;
}

export const SiteLoading: React.SFC<OwnProps> = (props) => {

    return (
        <div className="site-loading-wrapper">
        <div className="site-loading">
            <div className="circle"></div>
            <div className="ring1"></div>
            <div className="ring2"></div>
            <div className="ring3"></div>
            <div className="message">{props.message || <span>Loading&hellip;</span>}</div>
        </div>
    </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/generic/SiteLoading.tsx